import { useEffect, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import "../SearchLoad/AddSearchLoad.scss";
import { data } from "./SearchTruck.config";
import Addloadsection from "../AddMyLoad/Addloadsection/Addloadsection";
import FirstSectionModal from "../../CommonMultiSelectComponent/FirstSelectionModal";
import {
  Get_Vehicle_Category,
  Get_Vehicle_Category_By_Id,
  MatchingTrucks,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { useLazyQuery, useQuery } from "@apollo/client";
import PortalFooter from "../../Reactportal/PortalFooter";
import { useSelector } from "react-redux";
import { LoadTable } from "../..";
import { useModalContext } from "../../Reactportal/ModalContext";

export const SearchTruck = ({ TypeOfPortal, ParentPortalCloseFunction, show }) => {
  const [isVehicleCateSelected, setIsVehicleCateSelected] = useState(false);

     const { pushModal, popModal } = useModalContext();
  const [allFieldsData, setAllFieldsData] = useState();
  const [showVehicleCategory, setShowVehicleCategory] = useState();
  const [openSelectionModal, setOpenSelectionModal] = useState(false);
  const [tabelData, setTabelData] = useState([]);
  const [toggle, settoggle] = useState(show);
  const [formErrors, setFormErrors] = useState({});
  const [alldata, setalldata] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [selectedBranches, setSelectedBranch] = useState({});

  //Q
  const { data: vehicleCategoryData } = useQuery(Get_Vehicle_Category, {
    variables: {
      keyword: "",
    },
    fetchPolicy: "network-only",
  });
  const Form_Key = "Search_Trucks";

  const [getTruck, { loading: isLoading, error }] = useLazyQuery(MatchingTrucks, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  function mergeVehicleInfo(objectWithNames, vehicleTypeInfoArray) {
    let result = [];

    vehicleTypeInfoArray?.forEach((vehicleType) => {
      const key = vehicleType._id;
      if (objectWithNames.hasOwnProperty(key) && objectWithNames[key]?.length > 0) {
        let newItem = {
          VehicleType: vehicleType.Vehicle_Type,
          VehicleCategory: objectWithNames[key],
        };

        result.push(newItem);
      }
    });

    return result;
  }

  useEffect(() => {
    if (Object.keys(selectedBranches).length > 0) {
      let mergedArray = mergeVehicleInfo(selectedBranches, vehicleCategoryData?.searchVehicleTypeMasters);

      setShowVehicleCategory(mergedArray);
    }
  }, [selectedBranches, vehicleCategoryData]);

  useEffect(() => {
    if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
      setalldata(FormDataFromRedux[Form_Key]);
    }
  }, [FormDataFromRedux]);

  useEffect(() => {
    setAllFieldsData({
      destLocationRadius: 150,
      currentLocationRadius: 150,
    });
  }, [TypeOfPortal]);

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
  };
  const handleOpenSelectionModal = () => {
    setOpenSelectionModal(true);
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };


  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const submit = () => {
    let data = {};
    for (let key in alldata) {
      data = {
        ...data,
        ...alldata[key],
      };
    }
    data.Origin_Latitude = FormDataFromRedux?.MasterData[Form_Key]?.Loading_Name?.latitude;
    data.Origin_Longitude = FormDataFromRedux?.MasterData[Form_Key]?.Loading_Name?.longitude;
    data.Destination_Latitude = FormDataFromRedux?.MasterData[Form_Key]?.Unloading_Name?.latitude;
    data.Destination_Longitude = FormDataFromRedux?.MasterData[Form_Key]?.Unloading_Name?.longitude;
    delete data.Loading_Name;
    delete data.Unloading_Name;
    let vehicleId = [];
    for (let key in selectedBranches) {
      if (selectedBranches.hasOwnProperty(key) && key !== "SingleMultiSelectRows") {
        if (selectedBranches[key]) {
          selectedBranches[key].forEach((item) => {
            if (item._id) {
              vehicleId.push(item._id);
            }
          });
        }
      }
    }
    data.Vehicle_Category = vehicleId;
    getTruck({
      variables: {
        searchTruck: data,
      },
    }).then(({ data }) => {
      setTabelData(data.getMatchingTrucksForLoad);
    });
  };

  return (
    <Reactportal
      open={toggle}
      onClose={Closeformfunction}
      TypeOfPortal={TypeOfPortal}
      TypeOfId={"Account Id :"}
      UserRightsPortal={true}
    >
      <div className="SearchLoadContainer">
        {data.map((e) => {
          return (
            <div key={e.id} style={{ margin: "10px" }}>
              <Addloadsection
                inputfields={e.fields}
                Type={e.name}
                isVehicleCateSelected={isVehicleCateSelected}
                fielddata={allFieldsData}
                BidType=""
                TypeOfPortal={TypeOfPortal}
                ShowVehicleCategory={showVehicleCategory}
                handleOpenSelectionModal={() => handleOpenSelectionModal()}
                formkey={Form_Key}
                setAllFieldsData={setAllFieldsData}
                onErrorsChange={handleErrorsChange}
              />

              {openSelectionModal && (
                <FirstSectionModal
                  show={openSelectionModal}
                  query={Get_Vehicle_Category_By_Id}
                  getSelectedBranches={(data) => {
                    setSelectedBranch(data);
                  }}
                  selectedBranches={selectedBranches}
                  data={vehicleCategoryData && vehicleCategoryData.searchVehicleTypeMasters}
                  fielddata={selectedBranches}
                  TypeOfPortal={"Vehicle Category"}
                  setModal={() => setOpenSelectionModal(false)}
                />
              )}
            </div>
          );
        })}
        <LoadTable data={tabelData} loading={isLoading} error={error} title={"Search_Load"} />
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        Form_key={Form_Key}
        submitform={() => {
          submit();
        }}
        submitType={"Search"}
        TypeOfPortal={TypeOfPortal}
        handleFileDelete={() => { }}
        handleformclose={() => {
          Closeformfunction();
        }}
        loadingState={false}
      />
    </Reactportal>
  );
};
